<div class="d-flex jc-center ai-center">
  <div class="non-full-export-card card padding d-flex fd-col jc-center ai-center">
    <h4>
      Export <b>{{ tileInstance?.exportDisplayName }}</b>
      <mat-icon *ngIf="numberOfFilters" [matBadge]="numberOfFilters" matBadgeColor="warn"
        >filter_alt</mat-icon
      >
    </h4>

    <form *ngIf="optionsForm" [formGroup]="optionsForm">
      <div class="flex-1 d-flex fd-row ai-start">
        <mat-form-field appearance="outline" aria-label="File Name">
          <mat-label>File Name</mat-label>
          <input matInput formControlName="fileName" />
          <span matSuffix class="file-extension">.csv</span>
          <mat-error *ngIf="fileNameControl.invalid">
            {{ getFileNameError() }}
          </mat-error>
        </mat-form-field>

        <!-- <mat-button-toggle-group>
          <mat-button-toggle>.csv</mat-button-toggle>
          <mat-button-toggle>.pdf</mat-button-toggle>
        </mat-button-toggle-group> -->
      </div>
    </form>
  </div>
</div>
